import {helpers} from 'vuelidate/lib/validators';

export const alphaSpaces = helpers.regex('alphaSpaces', /^[a-zA-ZñÑ ]*$/);

/**
 * 
 * @param {string} mobileNumberRef 
 * @param {boolean} onlyValidateIfElementExists - Set to true if the element to be checked
 *    has a chance of being hidden. If so, you can have an option if you still want to
 *    include that element on validation or not.
 */
export const mobileNumberValid = (mobileNumberRef, onlyValidateIfElementExists = false) => {
  return (value, vm) => {
    if (onlyValidateIfElementExists) {
      if (!vm.$refs[mobileNumberRef]) {
        return true;
      }
    }

    return !!vm.$refs[mobileNumberRef].valid;
  };
};

export const requiredCheckBox = (value) => value === true;

/**
 * only supports if the `dateString` format is MM/DD/YYYY
 */
export const dateStringIsLessThan = (dateToCompareInMilli) => {
  return (dateString) => {
    const dateInMilli = Date.parse(dateString);
    return dateInMilli < dateToCompareInMilli;
  };
};

export const dateStringIsValid = (date) => {
  const split = date.split('/');

  if (split.length !== 3) return false;

  const month = Number(split[0]);
  const day = Number(split[1]);
  const year = Number(split[2]);
  const monthsDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // no leap year yet

  if (day <= 0 || month <= 0 || year < 1900) {
    return false;
  }

  if (month !== 2 && (day > monthsDays[month - 1])) {
    return false;
  }

  if (month === 2) {
    const isLeapYear = (!(year % 4) && year % 100) || !(year % 400);

    if (isLeapYear && day > 29) {
      return false;
    }

    if (!isLeapYear && day >= 29) {
      return false;
    }
  }

  return true;
};